




















import { Component, Vue, Watch, Prop } from "vue-property-decorator";

@Component({
  name: "enterpriseMien",
})
export default class extends Vue {
  @Prop()
  inputEnterpriseMienData: any;

  @Watch("inputEnterpriseMienData", { immediate: true, deep: true })
  oninputEnterpriseMienData(val: any, oldVal: any) {
    this.enterpriseMienData = val;
  }

  private enterpriseMienData: any = [];

  private strSub(str: any, len: any) {
    if (str.length > len) {
      return str.substr(0, len) + "..."; //截取元素的文本的长度并加上省略号
    }
  }

  private toDetail(item: any) {
    this.$router.push({
      name: "Article",
      query: {
        type: "2",
        landmarkId: item.landmark_id,
        id: item.id,
      },
    });
  }
}
